import styled from "styled-components";

export const NavbarStyle = styled.nav`
  position: fixed;
  top: 0;
  width: 100vw;
  padding: 10px 20px;
  display: grid;
  grid-template-columns: 60% 40%;
  align-items: center;
  background: lightcyan;
  z-index: 2;
  transition: background 0.5s ease;
  ul {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.9rem;
    &:last-child {
      justify-content: right;
      margin-right: 15px;
    }
    li {
      a {
        display: flex;
        align-items: center;
        text-decoration: none;
        &:hover {
          img {
            filter: invert(40%) sepia(94%) saturate(6890%) hue-rotate(329deg)
              brightness(95%) contrast(104%);
          }
        }
      }
      button {
        display: flex;
        align-items: center;
        background: none;
        border: none;
        font-weight: 600;
        line-height: 1em;
        gap: 5px;
        img {
          width: 20px;
          height: 20px;
        }
        &:hover {
          color: var(--pink);
        }
        &.language-button img {
          display: block;
          border-radius: 8px;
        }
      }
      &.dark-mode {
        button:hover img {
          filter: invert(40%) sepia(94%) saturate(6890%) hue-rotate(329deg)
            brightness(95%) contrast(104%);
        }
      }
      &.language-switcher {
        position: relative;
      }
    }
  }
  .language-menu {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 150px;
    padding: 6px;
    margin: 0;
    list-style: none;
    border-radius: 12px;
    background: #e8f5f9;
    box-shadow:
      0 8px 24px rgba(0, 0, 0, 0.12),
      0 2px 6px rgba(0, 0, 0, 0.06);
    z-index: 5;
    li {
      width: 100%;
    }
    button {
      width: 100%;
      justify-content: flex-start !important;
      gap: 8px;
      padding: 8px 10px;
      border-radius: 8px;
      font-weight: 500;
      color: #011627;
      &:hover {
        background: rgba(0, 0, 0, 0.05);
        color: #011627;
      }
      &.active {
        background: rgba(0, 0, 0, 0.06);
        font-weight: 700;
      }
      img {
        width: 20px;
        height: 20px;
        border-radius: 4px;
      }
    }
  }
  &.dark {
    background: #010d1a;
    .nav-github {
      filter: invert(100%) sepia(17%) saturate(7417%) hue-rotate(183deg)
        brightness(114%) contrast(100%);
    }
    .dark-mode-sun:hover {
      color: transparent;
      text-shadow: 0 0 0 var(--pink);
    }
    .language-menu {
      background: #0a1e33;
      box-shadow:
        0 8px 24px rgba(0, 0, 0, 0.4),
        0 2px 6px rgba(0, 0, 0, 0.2);
      button {
        color: #fff;
        &:hover {
          background: rgba(255, 255, 255, 0.08);
          color: #fff;
        }
        &.active {
          background: rgba(255, 255, 255, 0.12);
        }
      }
    }
  }

  @media (max-width: 420px) {
    display: flex;
    gap: 5px;
    justify-content: space-between;
    .language-label {
      display: none !important;
    }
    ul,
    img {
      margin: 0 !important;
    }
  }
`;